var map = {
	"./airBaltic-club-logo.svg": 646,
	"./american-express.svg": 1088,
	"./applepay.svg": 1089,
	"./bitpay.png": 1090,
	"./capa.svg": 1091,
	"./google.svg": 1092,
	"./googlepay.svg": 1093,
	"./instagram.svg": 1094,
	"./klix-logo.svg": 1095,
	"./master-card.svg": 1096,
	"./oag/de.svg": 1097,
	"./oag/en.svg": 1098,
	"./oag/et.svg": 1099,
	"./oag/fi.svg": 1100,
	"./oag/lt.svg": 1101,
	"./oag/lv.svg": 1102,
	"./oag/ru.svg": 1103,
	"./pay-pal.svg": 1104,
	"./pins.svg": 1105,
	"./trustly.png": 1106,
	"./uatp.png": 1107,
	"./visa.svg": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1087;